export default class Validation {
  static defaultReturn = { valid: true, message: '' };
}
